export default __webpack_public_path__ + "static/media/icon_users.e1fbee36.svg";